export default __webpack_public_path__ + "static/media/map_background.3527a103.jpg";